import React, { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";

function App() {

const [chat, setChat] = useState([
{ text: "Hello 👋 I am Nova AI. Ask me anything about AI Innovia Academy!", user: false }
]);

const [msg, setMsg] = useState("");
const [loading, setLoading] = useState(false);
const chatEndRef = useRef(null);

useEffect(() => {
chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [chat]);

const sendMsg = async () => {

if (!msg.trim()) return;

const userText = msg;

setChat(prev => [...prev, { text: userText, user: true }]);
setMsg("");
setLoading(true);

try {

const res = await fetch("/api/ask-nova", {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ message: userText })
});

const data = await res.json();

setChat(prev => [...prev, { text: data.reply, user: false }]);

} catch {

setChat(prev => [...prev, { text: "Nova AI error.", user: false }]);

}

setLoading(false);

};

const section = {
padding: "100px 20px",
textAlign: "center"
};

const logoCircle = (text,color)=>({
width:100,
height:100,
borderRadius:"50%",
background:color,
display:"flex",
alignItems:"center",
justifyContent:"center",
fontSize:28,
fontWeight:"bold",
margin:"0 auto 20px",
boxShadow:"0 0 25px rgba(56,189,248,0.5)"
});

return (

<div style={{background:"linear-gradient(135deg,#020617,#0f172a)",color:"white",fontFamily:"Segoe UI"}}>

{/* HERO */}

<section style={{textAlign:"center",padding:"120px 20px"}}>

<div style={logoCircle("AI","linear-gradient(135deg,#38bdf8,#818cf8)")}>AI</div>

<h1 style={{fontSize:50,color:"#38bdf8"}}>AI-INNOVIA Academy</h1>

<p style={{color:"#94a3b8",fontSize:20}}>
Your Right Mentor for IIT-JEE NEET Foundation
</p>

</section>

{/* WHY AI INNOVIA */}

<section style={section}>

<h2 style={{fontSize:36,color:"#38bdf8"}}>Why AI Innovia Academy?</h2>

<p style={{maxWidth:900,margin:"30px auto",color:"#94a3b8",lineHeight:1.8,fontSize:18}}>
Located in Latur, Maharashtra, AI Innovia Academy combines technology, discipline and strong conceptual teaching to prepare students for IIT-JEE and NEET foundation. Our structured programs develop analytical thinking, confidence and academic excellence.
</p>

</section>

{/* NEXUS LIBRARY */}

<section style={{...section,background:"#020617"}}>

<div style={logoCircle("NL","linear-gradient(135deg,#0ea5e9,#22d3ee)")}>NL</div>

<h2 style={{fontSize:36,color:"#38bdf8"}}>Nexus Digital Library</h2>

<p style={{maxWidth:900,margin:"30px auto",color:"#94a3b8",lineHeight:1.8,fontSize:18}}>
Our Nexus Digital Library is powered by advanced Kindle devices, providing students with 
a distraction-free digital reading environment. Students can access textbooks, competitive 
exam materials, and curated academic resources instantly. This system encourages focused 
reading habits and helps students explore unlimited knowledge efficiently.
</p>

</section>

{/* MATH LAB */}

<section style={section}>

<div style={logoCircle("ML","linear-gradient(135deg,#22c55e,#16a34a)")}>ML</div>

<h2 style={{fontSize:36,color:"#38bdf8"}}>Infinity Math Lab</h2>

<p style={{maxWidth:900,margin:"30px auto",color:"#94a3b8",lineHeight:1.8,fontSize:18}}>
Experience Math in Action! Infinity Math Lab transforms mathematics into an engaging 
and practical learning experience. Through visual demonstrations, structured activities, 
and conceptual exploration, students build strong logical thinking and fearless 
problem-solving skills required for IIT-JEE and competitive exams.
</p>

</section>

{/* SPORT ZONE */}

<section style={{...section,background:"#020617"}}>

<div style={logoCircle("SZ","linear-gradient(135deg,#f59e0b,#f97316)")}>SZ</div>

<h2 style={{fontSize:36,color:"#38bdf8"}}>Sport Zone</h2>

<p style={{maxWidth:900,margin:"30px auto",color:"#94a3b8",lineHeight:1.8,fontSize:18}}>
Our Sport Zone promotes holistic development by balancing academics with physical 
activity. Structured sports programs improve discipline, stamina, teamwork, and 
mental clarity. A healthy body supports a focused mind, helping students perform 
better academically and develop confidence in everyday challenges.
</p>

</section>

{/* AI LAB */}

<section style={section}>

<div style={logoCircle("AR","linear-gradient(135deg,#a78bfa,#6366f1)")}>AR</div>

<h2 style={{fontSize:36,color:"#38bdf8"}}>AI Research & Science Lab</h2>

<p style={{maxWidth:900,margin:"30px auto",color:"#94a3b8",lineHeight:1.8,fontSize:18}}>
The AI Research & Science Lab is an innovation hub where students explore robotics, 
artificial intelligence concepts, and scientific experimentation. This lab encourages 
curiosity, creativity, and analytical thinking. Students gain exposure to modern 
technology and develop problem-solving skills essential for future engineers and scientists.
</p>

</section>

{/* FEES */}

<section style={{ padding: "100px 20px", background: "#020617", textAlign: "center" }}>

<h2 style={{ fontSize: 36, color: "#38bdf8", marginBottom: 50 }}>
Fees Structure
</h2>

<div style={{
display: "grid",
gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
gap: 40,
maxWidth: 1000,
margin: "auto"
}}>

{/* Residential Program */}

<div style={{
background: "#0f172a",
padding: 40,
borderRadius: 20,
border: "1px solid #1e293b",
boxShadow: "0 0 25px rgba(56,189,248,0.15)"
}}>

<h3 style={{ fontSize: 24, marginBottom: 20 }}>
Residential Program
</h3>

<p style={{
fontSize: 42,
fontWeight: "bold",
color: "#22c55e",
marginBottom: 20
}}>
₹1,25,000
</p>

<div style={{
marginTop: 10,
textAlign: "left",
color: "#cbd5f5",
marginBottom: 20
}}>

<strong>Installments:</strong>

<p>• First Installment: ₹62,500</p>

<p>• Second Installment (After Diwali): ₹62,500</p>

</div>

<p style={{
fontSize: 14,
color: "#94a3b8",
marginBottom: 20
}}>
Please send screenshot on <strong>9850602559</strong> for admission confirmation.
</p>

<a href="https://razorpay.me/@aiinnovia" target="_blank" rel="noreferrer">
<button style={{
background: "#6366f1",
color: "white",
padding: "14px",
borderRadius: "12px",
border: "none",
width: "100%",
fontWeight: "bold",
cursor: "pointer"
}}>
Pay Fees Online
</button>
</a>

<a href="https://wa.me/919850602559?text=Hello%20I%20want%20to%20enroll%20in%20Residential%20Program%20at%20AI%20Innovia%20Academy" target="_blank" rel="noreferrer">
<button style={{
marginTop: "15px",
background: "#22c55e",
color: "white",
padding: "14px",
borderRadius: "12px",
border: "none",
width: "100%",
fontWeight: "bold",
cursor: "pointer"
}}>
Enroll Now
</button>
</a>

</div>

{/* Non-Residential Program */}

<div style={{
background: "#0f172a",
padding: 40,
borderRadius: 20,
border: "1px solid #1e293b",
boxShadow: "0 0 25px rgba(56,189,248,0.15)"
}}>

<h3 style={{ fontSize: 24, marginBottom: 20 }}>
Non-Residential Program
</h3>

<p style={{
fontSize: 42,
fontWeight: "bold",
color: "#22c55e",
marginBottom: 20
}}>
₹30,000
</p>

<div style={{
marginTop: 10,
textAlign: "left",
color: "#cbd5f5",
marginBottom: 20
}}>

<strong>Installments:</strong>

<p>• First Installment: ₹15,000</p>

<p>• Second Installment (After Diwali): ₹15,000</p>

</div>

<p style={{
fontSize: 14,
color: "#94a3b8",
marginBottom: 20
}}>
Please send screenshot on <strong>9850602559</strong> for admission confirmation.
</p>

<a href="https://razorpay.me/@aiinnovia" target="_blank" rel="noreferrer">
<button style={{
background: "#6366f1",
color: "white",
padding: "14px",
borderRadius: "12px",
border: "none",
width: "100%",
fontWeight: "bold",
cursor: "pointer"
}}>
Pay Fees Online
</button>
</a>

<a href="https://wa.me/919850602559?text=Hello%20I%20want%20to%20enroll%20in%20Non-Residential%20Program%20at%20AI%20Innovia%20Academy" target="_blank" rel="noreferrer">
<button style={{
marginTop: "15px",
background: "#22c55e",
color: "white",
padding: "14px",
borderRadius: "12px",
border: "none",
width: "100%",
fontWeight: "bold",
cursor: "pointer"
}}>
Enroll Now
</button>
</a>

</div>

</div>

</section>


{/* NOVA AI */}

<section style={{maxWidth:600,margin:"80px auto",padding:30,background:"#020617",borderRadius:20}}>

<h3 style={{textAlign:"center",color:"#38bdf8"}}>Nova AI Assistant</h3>

<div style={{height:250,overflowY:"auto",marginTop:20}}>

{chat.map((c,i)=>(
<div key={i} style={{textAlign:c.user?"right":"left",marginBottom:10}}>

<span style={{
background:c.user?"#0ea5e9":"#1e293b",
padding:"10px 15px",
borderRadius:15,
display:"inline-block"
}}>

<ReactMarkdown>{c.text}</ReactMarkdown>

</span>

</div>
))}

{loading && <p style={{color:"#94a3b8"}}>Nova is thinking...</p>}

<div ref={chatEndRef}></div>

</div>

<div style={{display:"flex",gap:10,marginTop:15}}>

<input
value={msg}
onChange={(e)=>setMsg(e.target.value)}
onKeyDown={(e)=>{if(e.key==="Enter") sendMsg();}}
style={{flex:1,padding:"12px",borderRadius:10,border:"none"}}
/>

<button
onClick={sendMsg}
style={{padding:"12px 20px",borderRadius:10,border:"none",background:"#0ea5e9",color:"white"}}
>
Send
</button>

</div>

</section>

{/* FLOATING BUTTONS */}

<div style={{position:"fixed",bottom:25,right:25,display:"flex",flexDirection:"column",gap:12}}>

<a href="tel:+919850602559" style={{background:"#2563eb",padding:14,borderRadius:"50%",fontSize:20}}>
📞
</a>

<a href="https://wa.me/919850602559" target="_blank" rel="noreferrer" style={{background:"#22c55e",padding:14,borderRadius:"50%",fontSize:20}}>
💬
</a>

</div>

<footer style={{padding:"80px 20px",textAlign:"center"}}>
<p style={{color:"#94a3b8"}}>
© {new Date().getFullYear()} AI Innovia Academy • Latur, Maharashtra
</p>
</footer>

</div>

);
}

export default App;